import './pagination.styl';

import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';
import {Link} from 'react-router';
import {Range} from 'immutable';

import scrollTo from '../../lib/scrollTo';
import {searchInGoogle} from '../../../common/search/actions';

const MAX_PAGES_DISPLAY = 10;
const DEFAULT_PER_PAGE_RESULTS = 10;

const ifPageAvailable = (totalPages, pageNumber) => {
  return totalPages >= pageNumber ? pageNumber : totalPages;
};

const Pagination = ({searchInformation, pending, searchInGoogle, location}) => {
  const countTotal = parseInt(searchInformation.totalResults);
  const countTotalPages = countTotal / DEFAULT_PER_PAGE_RESULTS;
  const currentPage = location.query ? (location.query.page || 1) : 1;

  // const pagesArray = currentPage < MAX_PAGES_DISPLAY
  //   ? Range(1, ifPageAvailable(countTotalPages, MAX_PAGES_DISPLAY + 1))
  //   : Range(currentPage - (MAX_PAGES_DISPLAY / 2),
  //     ifPageAvailable(countTotalPages, (MAX_PAGES_DISPLAY / 2) + currentPage + 1));

  const pagesArray = Range(1, ifPageAvailable(countTotalPages, MAX_PAGES_DISPLAY + 1));

  return (
    <div
      className={classNames({
        pagination: true,
        pagination_pending: pending
      })}
    >
      <div className="pagination__items">
        {pagesArray.map((page, index) => {
          const query = {...location.query, page};

          return (
            <Link
              to={{pathname: location.pathname, query}}
              key={index}
              onClick={() => {
                searchInGoogle(query);
                scrollTo();
              }}
              className={classNames({
                pagination__item: true,
                pagination__item_current: currentPage == page
              })}
            >{page}</Link>
          );
        })}
      </div>
    </div>
  );
};

Pagination.propTypes = {
  searchInGoogle: React.PropTypes.func.isRequired,
  searchInformation: React.PropTypes.object,
  location: React.PropTypes.object,
  pending: React.PropTypes.bool
};


export default connect(state => ({
  pending: state.search.pending,
  searchInformation: state.search.searchInformation
}), {searchInGoogle})(Pagination);



// WEBPACK FOOTER //
// ./src/client/components/pagination/Pagination.js